/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class PatchedHorseMedicalDetailsRequest {
    'isInjured'?: boolean;
    'weight'?: number;
    'allergies'?: string;
    'sickness'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "isInjured",
            "baseName": "isInjured",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "weight",
            "baseName": "weight",
            "type": "number",
            "format": "double"
        },
        {
            "name": "allergies",
            "baseName": "allergies",
            "type": "string",
            "format": ""
        },
        {
            "name": "sickness",
            "baseName": "sickness",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PatchedHorseMedicalDetailsRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

